import React from 'react';
function Briefcase({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M9 8V6.645c0-.702.253-1.374.703-1.87A2.293 2.293 0 0111.4 4h1.2c.636 0 1.247.279 1.697.775.45.496.703 1.168.703 1.87v1.289M13.2 15.429H21V9.143c0-.303-.127-.594-.352-.808A1.231 1.231 0 0019.8 8H12m8.4 7.429V20H12M10.8 15.429H3V9.143c0-.303.126-.594.351-.808C3.577 8.12 3.881 8 4.2 8H12m-8.4 7.429V20H12"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M11 14h2v3h-2v-3z"
      />
    </svg>
  );
}

export default Briefcase;
